import { connect } from "react-redux";
import AddNewComment from "./addComment";
import { AddComment } from "../../../../redux/actions/newService/comment.actions";
import { openAlertPopup } from "../../../../redux/actions/Alert/alert.action";
import { getActivityLog, getDemandComments } from "../../../../redux/actions/demand/demand.action";


const mapStateToProps = (state) => {
  return {
    myRights: state.myRights.myRights,
    demandComments:state.demandComment.comments,
    isCommentLoading:state.demandComment.isLoading,
    activitylogs:state.activitylog,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      addComment: (payload,id) => {
        return dispatch(AddComment(payload,id))
      },
      getDemandComments:(requestId,next=null)=>{
        return dispatch(getDemandComments(requestId,next))
      },
      openAlertPopup: (payload) => {
        return dispatch(openAlertPopup(payload))
      },
      getActivityLog: (id) => {
        return dispatch(getActivityLog(id))
      },
  }
};


export default connect(mapStateToProps, mapDispatchToProps)(AddNewComment);